import { TypeHelper } from "../../helpers"

import { IJsonSerializable, IOpChangeState, IOpObject, IReferenceType, ICopyable } from "../util/interfaces"
import { OpDataList } from "../util"

import { Enums } from "../common"

import { OpDescr } from "./op-descr"
import { OpArticleData } from "./op-article-data"


export class OpArticle implements IJsonSerializable, IOpChangeState, IOpObject, IReferenceType, ICopyable<OpArticle>  {

    //#region Properties

    public description: string
    public externalId: number
    public idArticle: number
    public idDescr: number
    public isAiut: boolean
    public isUnique: boolean
    public name: string
    public visible: boolean

    //#endregion


    //#region NavigationProperties

    private _descr: OpDescr
    public get descr(): OpDescr {
        return this._descr
    }
    public set descr(value: OpDescr) {
        this._descr = value
        this.idDescr = value != null ? value.idDescr : null
    }

    //#endregion


    //#region Custom Properties

    public dynamicValues: { Key: string, Value: any }[] = []

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region toString

    public toString(): string {
        if (this.descr != null) {
            return this.descr.description
        }

        if (!TypeHelper.isNullOrEmpty(this.name)) {
            return this.name
        }

        return "[unknown]";
    }

    //#endregion


    //#region IOpObject Implementation

    public get idObject(): any {
        return this.idArticle
    }
    public set idObject(idObject: any) {
        this.idArticle = idObject
    }

    public dataList: OpDataList<OpArticleData> = new OpDataList<OpArticleData>()

    public customFormatString: string;

    public opState: Enums.OpChangeState;

    //#endregion


    //#region IReferenceType

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdArticle
    }

    public getReferenceKey(): number {
        return this.idArticle
    }

    public getReferenceValue() {
        return this
    }

    //#endregion


    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null

            if (opObj.DataList) {
                this.dataList.push(...opObj.DataList.map(data => new OpArticleData(data)))
            }

            this.description = opObj.DESCRIPTION
            this.externalId = opObj.EXTERNAL_ID
            this.idArticle = opObj.ID_ARTICLE
            this.idDescr = opObj.ID_DESCR
            this.isAiut = opObj.IS_AIUT
            this.isUnique = opObj.IS_UNIQUE
            this.name = opObj.NAME
            this.visible = opObj.VISIBLE

            this.opState = opObj.OpState

            this.dynamicValues = opObj.dynamicValues
        } else {
            this.idArticle = 0

            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            DataList: this.dataList ? this.dataList.ToJSON(true) : null,

            DESCRIPTION: this.description,
            EXTERNAL_ID: this.externalId,
            ID_ARTICLE: this.idArticle,
            ID_DESCR: this.idDescr,
            IS_AIUT: this.isAiut,
            IS_UNIQUE: this.isUnique,
            NAME: this.name,
            VISIBLE: this.visible,

            OpState: this.opState,

            dynamicValues: this.dynamicValues,
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public copy(source: OpArticle, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            if (source.descr != null) {
                this.descr = source.descr
            }
        }

        if (includeCustomProperties) {
        }

        if (includeDataList && source.dataList != null) {
            this.dataList = source.dataList.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
        }

        if (includeDynamicValues) {
            this.dynamicValues = TypeHelper.clone(source.dynamicValues, true)
        }

        this.description = source.description
        this.externalId = source.externalId
        this.idArticle = source.idArticle
        this.idDescr = source.idDescr
        this.isAiut = source.isAiut
        this.isUnique = source.isUnique
        this.name = source.name
        this.visible = source.visible
        this.opState = source.opState
    }

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpArticle {
        const newPackage = new OpArticle(null)

        newPackage.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newPackage
    }

    //#endregion
}